import ConfirmCancelButtons from '@/components/molecules/ConfirmationModal/ConfirmCancelButtons';
import ModalContainer from '@/components/molecules/ModalContainer/ModalContainer';
import { Text, Textarea, VStack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

interface Props {
  isOpen: boolean;
  isLoading: boolean;
  onCancel: () => void;
  onConfirm: (decisionNotes: string) => void;
}

const MIN_REJECT_REASON_LENGTH = 10;

const RejectApplicationModal = ({ isOpen, isLoading, onCancel, onConfirm }: Props) => {
  const [decisionNotes, setDecisionNotes] = useState('');

  // Reset the field whenever the modal is reopened.
  useEffect(() => {
    if (isOpen) {
      setDecisionNotes('');
    }
  }, [isOpen]);

  const trimmedNotes = decisionNotes.trim();

  return (
    <ModalContainer
      isOpen={isOpen}
      onClose={onCancel}
      title="Reject Application"
      footerContent={
        <ConfirmCancelButtons
          confirmButtonText="Reject"
          confirmButtonColor="extra.red"
          confirmButtonDisabled={!trimmedNotes || trimmedNotes.length < MIN_REJECT_REASON_LENGTH}
          confirmLoading={isLoading}
          onCancel={onCancel}
          onConfirm={() => onConfirm(trimmedNotes)}
          marginBottom="0"
        />
      }
    >
      <VStack align="stretch" gap="10px" marginY="20px">
        <Text fontSize="16px">Let the applicant know what needs to change. This message is shared with them.</Text>
        <Textarea
          backgroundColor="white"
          minHeight="120px"
          placeholder="Reason for rejection"
          value={decisionNotes}
          onChange={(event) => setDecisionNotes(event.target.value)}
        />
      </VStack>
    </ModalContainer>
  );
};

export default RejectApplicationModal;
